import { heroStats, quickNav } from "@/mocks/eventArchive";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=minimalist%20editorial%20archive%20collage%20on%20warm%20cream%20paper%2C%20stacks%20of%20torn%20newspaper%20headline%20strips%20and%20overlapping%20document%20sheets%2C%20bold%20charcoal%20serif%20type%20blocks%20mixed%20with%20thin%20timeline%20rules%2C%20vermilion%20orange%20marker%20accent%20dots%20and%20line%20dividers%2C%20generous%20negative%20space%2C%20abstract%20newsroom%20archive%20concept%2C%20no%20faces%2C%20flat%20soft%20light%2C%20editorial%20print%20texture&width=1600&height=900&seq=hero51-x01&orientation=landscape"
          alt="51反差 事件档案整理背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/60 to-background-50"></div>
      </div>

      <div className="relative mx-auto max-w-6xl px-4 md:px-6 pb-12 pt-28 md:pb-16 md:pt-40">
        <div className="flex flex-col items-center text-center">
          <span className="sec-kicker inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100/70 px-4 py-1.5 text-xs font-semibold text-primary-800">
            <i className="ri-fire-line"></i>51反差 · 事件始末一站式归档
          </span>

          <h1 className="font-head-cn mt-7 max-w-4xl text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
            51反差事件<span className="text-primary-600">全记录</span>，
            <br className="hidden md:block" />
            按时间线叠好完整始末
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-7 text-foreground-700 md:text-lg">
            从爆发到后续发展、每一条截图的时间对应关系，都替你按阶段收拢在一条时间轴上。
            想看全程回顾的同学，不用再爬上百个散帖——前因后果与各阶段变化，这边一条线直接串完。
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#shijianxian"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-time-line"></i>进入全记录时间线
            </a>
            <a
              href="#jieduan"
              className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50/70 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
            >
              <i className="ri-route-line"></i>看阶段拆解
            </a>
          </div>

          {/* 数据带 */}
          <div className="mt-12 grid w-full grid-cols-2 gap-3 sm:grid-cols-4">
            {heroStats.map((s) => (
              <div
                key={s.label}
                className="flex flex-col items-center justify-center rounded-lg border border-background-200 bg-background-50/80 px-4 py-5"
              >
                <span className="font-num text-4xl leading-none text-foreground-950">{s.num}</span>
                <span className="mt-2 text-xs font-medium tracking-wide text-foreground-600">{s.label}</span>
              </div>
            ))}
          </div>

          {/* 快速跳转 */}
          <div className="mt-8 flex w-full flex-wrap items-center justify-center gap-2">
            {quickNav.map((q) => (
              <a
                key={q.id}
                href={`#${q.id}`}
                className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50/70 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-accent-400 hover:bg-accent-100 hover:text-accent-900 whitespace-nowrap"
              >
                <i className={q.icon}></i>{q.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="relative h-10 overflow-hidden">
        <div className="absolute inset-x-0 top-0 flex h-full items-end">
          <span className="font-num text-[120px] leading-none tracking-tight text-foreground-950/5 whitespace-nowrap select-none">
            51 CHA · FAN · TIMELINE ARCHIVE · 51 CHA · FAN · TIMELINE ARCHIVE
          </span>
        </div>
      </div>
    </section>
  );
}